import React, { useState } from 'react';
import { getClassAvailability } from '../../../../actions/feedActions';
import ReactDatePicker from 'react-datepicker';


const ReScheduleDemo = (props) => {
    const [availableTimings, setavailableTimings] = useState([]);
    const [teacherId, setteacherId] = useState("");
    const [timingsArray, settimingsArray] = useState([]);
    const [selectedTimeTable, setselectedTimeTable] = useState("");
    const [disableDays, setdisableDays] = useState([]);
    const [demoDate, setdemoDate] = useState("");
    const [demoTime, setdemoTime] = useState("");
    const [demoDay, setdemoDay] = useState('');


    const getClassAvailabilityHit = () => {
        console.log("Course ID", props.courseId);
        getClassAvailability(props.courseId)
            .then((res) => {
                setavailableTimings(res.data.result);
                console.log("Response of available class", res);
            })
    }

    const onTimeTableSelectModal = (timeData, teacherInfo, students) => {
        console.log("Timings List", timeData);
        console.log("Teacher Info", teacherInfo);
        setteacherId(teacherInfo[0]['teacherid']);
        const timingClone = [];
        const disableDaysClone = [];
        setselectedTimeTable(timeData);
        Object.keys(timeData).map((id, key) => {
            var day = timeData[id];

            //making logic for disable Days
            if (day.day.includes("Sunday") && day.is_on) {
                disableDaysClone.push(0)
            }
            else if (day.day.includes("Monday") && day.is_on) {
                disableDaysClone.push(1)
            }
            else if (day.day.includes("Tuesday") && day.is_on) {
                disableDaysClone.push(2)
            }
            else if (day.day.includes("Wednesday") && day.is_on) {
                disableDaysClone.push(3)
            }
            else if (day.day.includes("Thursday") && day.is_on) {
                disableDaysClone.push(4)
            }
            else if (day.day.includes("Friday") && day.is_on) {
                disableDaysClone.push(5)
            }
            else if (day.day.includes("Saturday") && day.is_on) {
                disableDaysClone.push(6)
            }

            //Logic for timetable
            if (day.start != '' && day.end != '') {
                var start_time = day.start;
                var firstCharStart = start_time.split("");
                if (firstCharStart[0] == '0') {
                    start_time = start_time.substring(1);
                }

                var end_time = day.end;
                var firstCharEnd = end_time.split("");
                if (firstCharEnd[0] == '0') {
                    end_time = end_time.substring(1);
                }

                let dayData =
                    <tr>
                        <td>{day.day_date}</td>
                        <td><i className="fas fa-clock mr-1"></i> {start_time} - {end_time}</td>
                        <td><i className="fas fa-user mr-1"></i><span className="text-success font-weight-bold"> {students} </span>{day.demo_students != 0 ? <React.Fragment> + <span style={{ color: '#e75480' }} className="font-weight-bold"> {day.demo_students} </span></React.Fragment> : null}</td>
                    </tr>

                timingClone.push(dayData);
            }
        })

        settimingsArray(timingClone);
        setdisableDays(disableDaysClone);
    }

    const isDisabled = (date) => {
        const day = date.getDay(date);
        return disableDays.includes(day);
    }

    const cardSelect = (teacherId) => {
        setteacherId(teacherId);
        setdemoDay('');
        setdemoTime('');
        // setwaitingList(0);
        // setloopCount(false);
    }

    const selectDay = (day, time) => {
        console.log("Day is:", day, "Time is: ", time, "Teacher Id", teacherId);
        setdemoDay(day);
        setdemoTime(time);
    }

    const NextStep = (waitingListCheck) => {
        if (demoDay && demoTime) {
            var demoObj = {
                demoDay,
                demoTime,
                teacherId,
                waitingList: waitingListCheck
            }
            // localStorage.setItem("demoObject", JSON.stringify(demoObj));
            console.log("Demo Object", demoObj);
        }
        // else {
        //     toast.error("Please select a day for your demo");
        // }
    }
    const NextStepWaitingList = (waitingListCheck) => {
        var demoObj = {
            demoDay: 0,
            demoTime: 0,
            teacherId,
            waitingList: waitingListCheck
        }
        // localStorage.setItem("demoObject", JSON.stringify(demoObj));
        console.log("Demo Object", demoObj);
    }

    const returnListTimings = (courseTimings) => {
        let daysArary = [];

        var timings = courseTimings;
        timings = JSON.parse(timings);
        console.log("TIMINGS", timings)
        Object.keys(timings).map((id, key) => {
            var day = timings[id];
            if (day.start != '' && day.end != '') {
                var start_time = day.start;
                var firstCharStart = start_time.split("");
                if (firstCharStart[0] == '0') {
                    start_time = start_time.substring(1);
                }

                var end_time = day.end;
                var firstCharEnd = end_time.split("");
                if (firstCharEnd[0] == '0') {
                    end_time = end_time.substring(1);
                }

                var dayName = day.day.split("");

                let dayData =
                    <React.Fragment>
                        <li key={key}>
                            <div className="d-flex justify-content-between">
                                {day.day_date}
                                <div className="text-center">
                                    <span className="">{start_time} - {end_time}</span>
                                </div>
                                <div className="text-center">
                                    <button disabled={day.total_students >= 7 ? true : false} className={day.total_students >= 7 ? 'selectBtnDisabled ml-2' : demoDay === day.day_date ? "selectBtnChecked ml-2" : "selectBtn ml-2"} onClick={() => selectDay(day.day_date, start_time)}>
                                        {day.total_students >= 7 ? "Full" : demoDay === day.day_date ? <span><i className="fas fa-check"></i></span> : "Select"}
                                        {/* {demoDay === day.day_date ? <span><i className="las la-check mr-1"></i></span> : "Select"} */}
                                    </button>
                                </div>
                            </div>
                        </li>
                    </React.Fragment>
                // checkAvailability(day, 7, key);
                daysArary.push(dayData);
                console.log(start_time, end_time)
            }
        })
        return daysArary;
    }
    return (
        <div>
            <button data-toggle="modal" data-target={`#myModal${props.id}`} className="btn btn-success zoomBtn mt-3" onClick={() => getClassAvailabilityHit()}>Re-schedule Demo</button>

            <div className="modal fade" tabIndex="-1" role="dialog" id={`myModal${props.id}`}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{props.programName}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <label className="font-weight-bold">Available timings</label>
                                </div>
                                <div className="col-md-12">
                                    <div id={`accordionGroupForClasses${props.id}`} key={props.id} className="">

                                        {availableTimings && availableTimings.map((item, index) =>
                                            item.show_on_website === 0 && item.total_students > 0 ?
                                                <div className="card mt-3 tutorsCard" key={index}>
                                                    <div className="d-flex justify-content-between mt-3" data-toggle="collapse" data-target={`#collapse${index}`} onClick={() => cardSelect(item.teacher_id)}>
                                                        <div className="d-flex">
                                                            <img className="" src={JSON.parse(item.teachers_info)[0]['img_src']} width="40" height="40" />
                                                            <div>
                                                                <label className="ml-2"><span>{JSON.parse(item.teachers_info)[0]['name']}</span></label>
                                                                <div className="timeSection">
                                                                    <label className="">{JSON.parse(item.Timing)[1]['start'].substring(1)} - {JSON.parse(item.Timing)[1]['end'].substring(1)}</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <button className="btn btn-light btn-sm joinButton">Join</button>
                                                        </div>
                                                    </div>

                                                    <div id={`collapse${index}`} class="collapse" aria-labelledby="headingOne" data-parent={`#accordionGroupForClasses${props.id}`}>
                                                        <div class="card-body p-0 mb-3">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="text-left">
                                                                    <span className="text-danger" style={{ fontSize: 12 }}>*Please select a day for your demo</span>
                                                                </div>
                                                                <div className="text-right">
                                                                    <span className="mr-2">Asia/Karachi</span>
                                                                </div>
                                                            </div>
                                                            <ul className="list-unstyled daysList">
                                                                {returnListTimings(item.Timing)}
                                                            </ul>

                                                            {!item.waitinglist == 1 ?
                                                                <div>
                                                                    <button className='btn btn-success btn-block btn-lg mt-2' onClick={() => NextStep(item.waitinglist)}>Next</button>
                                                                </div>
                                                                : <div>
                                                                    <button className='btn btn-success btn-block btn-lg mt-2' onClick={() => NextStepWaitingList(item.waitinglist)}>Join Waiting Room</button>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                : item.show_on_website === 1 ?

                                                    <div className="card mt-3 tutorsCard" key={index}>
                                                        <div className="d-flex justify-content-between mt-3" data-toggle="collapse" data-target={`#collapse${index}`} onClick={() => cardSelect(item.teacher_id)}>
                                                            <div className="d-flex">
                                                                <img className="" src={JSON.parse(item.teachers_info)[0]['img_src']} width="40" height="40" />
                                                                <div>
                                                                    <label className="ml-2"><span>{JSON.parse(item.teachers_info)[0]['name']}</span></label>
                                                                    <div className="timeSection">
                                                                        <label className="">{JSON.parse(item.Timing)[1]['start'].substring(1)} - {JSON.parse(item.Timing)[1]['end'].substring(1)}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <button className="btn btn-light btn-sm joinButton">Join</button>
                                                            </div>
                                                        </div>

                                                        <div id={`collapse${index}`} class="collapse" aria-labelledby="headingOne" data-parent={`#accordionGroupForClasses${props.id}`}>
                                                            <div class="card-body p-0 mb-3">
                                                                <div className="d-flex justify-content-between">
                                                                    <div className="text-left">
                                                                        <span className="text-danger" style={{ fontSize: 12 }}>*Please select a day for your demo</span>
                                                                    </div>
                                                                    <div className="text-right">
                                                                        <span className="mr-2">Asia/Karachi</span>
                                                                    </div>
                                                                </div>
                                                                <ul className="list-unstyled daysList">
                                                                    {returnListTimings(item.Timing)}
                                                                </ul>

                                                                {!item.waitinglist == 1 ?
                                                                    <div>
                                                                        <button className='btn btn-success btn-block btn-lg mt-2' onClick={() => NextStep(item.waitinglist)}>Next</button>
                                                                    </div>
                                                                    : <div>
                                                                        <button className='btn btn-success btn-block btn-lg mt-2' onClick={() => NextStepWaitingList(item.waitinglist)}>Join Waiting Room</button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    : null
                                        )}

                                        {/* <div class="card mt-3">
                                        <div className="backgroundForOneonOneClass d-flex justify-content-between collapsed" data-toggle="collapse" data-target={`#collapseOne`}>
                                            <div className="text-center">
                                                <label className="text-dark font-weight-bold">Schedule Demo for 1 on 1 class</label>
                                            </div>
                                            <div>
                                                <i className="fas fa-chevron-down ml-2 text-light"></i>
                                            </div>
                                        </div>

                                        <div id={`collapseOne`} class="collapse" aria-labelledby="headingOne" data-parent="#accordionGroup">
                                            <div class="card-body">
                                                {intrestedTeachers.length <= 0 ?
                                                    <div className="row text-center">
                                                        <div className="col-md-12">
                                                            <label className="font-weight-bold">Select date and time for the demo class:</label>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <DatePicker
                                                                selected={demoDateForTeacher}
                                                                onChange={(date) => setdemoDateForTeacher(date)}
                                                                // filterDate={isDisabled}
                                                                placeholderText="Select Date"
                                                                minDate={new Date()}
                                                                showTimeSelect
                                                                timeIntervals={15}
                                                                timeCaption="time"
                                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                                value={demoDateForTeacher}
                                                            />
                                                        </div>

                                                        <div className="col-md-12 mt-2 text-center mt-5">
                                                            <button className="btn btn-success btn-block" onClick={() => SendMessageToAllTutorsFunc()}>Send message to all Tutors</button>
                                                        </div>

                                                    </div>
                                                    :
                                                    <div className="row text-center">
                                                        <div className="col-md-12">
                                                            <label className="font-weight-bold">Intrested Teachers for this demo class:</label>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <select className="form-control" onChange={(e) => onchangeTeacher(e)}>
                                                                <option>Select Tutor</option>
                                                                {intrestedTeachers.map((item, index) =>
                                                                    <option key={index} value={JSON.stringify(item)}>{item.user_name}</option>
                                                                )}
                                                            </select>
                                                        </div>

                                                        <div className="col-md-12 mt-2 text-center mt-5">
                                                            <button className="btn btn-success btn-block" onClick={() => confirmTutor()}>Add tutor for this demo class</button>
                                                        </div>

                                                    </div>}
                                            </div>
                                        </div>
                                    </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}

export default ReScheduleDemo;